import { render, staticRenderFns } from "./FilterDimensionSelect.vue?vue&type=template&id=1e478eba&scoped=true"
import script from "./FilterDimensionSelect.vue?vue&type=script&lang=ts"
export * from "./FilterDimensionSelect.vue?vue&type=script&lang=ts"
import style0 from "./FilterDimensionSelect.vue?vue&type=style&index=0&id=1e478eba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e478eba",
  null
  
)

export default component.exports